import {ChartColors, ChartLabels} from '../../app/common/constants/chartColors'
import {AccountSettingsClient} from '../../app/infrastracture/api/AccountSettingsClient'
import * as accountSettings from '../../app/modules/account-themes/redux/AccountSettingRedux'

const RETRY_DELAY_MS = 5000

export const fetchAccountSettings = () => async (dispatch: any) => {
  try {
    if (await loadAccountSettings(dispatch)) return
  } catch (error) {
    console.error('Failed to fetch account settings:', error)
  }

  // A failed load leaves the CRM on its fallback labels, so try once more before giving up
  await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS))

  try {
    await loadAccountSettings(dispatch)
  } catch (error) {
    console.error('Failed to fetch account settings:', error)
  }
}

const loadAccountSettings = async (dispatch: any) => {
  const defaultSettings = await AccountSettingsClient.GetDefault()
  if (!defaultSettings.successful || !defaultSettings.data) return false

  const {data} = defaultSettings

  const color = data.accountThemes?.[0]

  if (color?.values) {
    const getColor = (key: string, fallback: string) =>
      color.values.find((x: any) => x.key === key)?.value ?? fallback

    const mappedColors = {
      OnSite: getColor('OnSite', ChartColors.OnSite),
      Home: getColor('Remote', ChartColors.Home),
      NoResponse: getColor('NoResponse', ChartColors.NoResponse),
      NotWorking: getColor('Leave', ChartColors.NotWorking),
      WhatsOnHoliday: getColor('WhatsOnHoliday', ChartColors.Holiday),
      WhatsOnEvent: getColor('WhatsOnEvent', ChartColors.Event),
      Available: getColor('Available', ChartColors.Available),
      Reserved: getColor('Reserved', ChartColors.Reserved),
      InUse: getColor('InUse', ChartColors.InUse),
      Booked: getColor('Booked', ChartColors.Booked),
      Item: getColor('Item', ChartColors.Item),
      Filters: getColor('Filters', ChartColors.Filters),
      ChartBackground: getColor('ChartBackground', ChartColors.ChartBackground),
      AssetMapLabel: getColor('AssetMapLabel', ChartColors.AssetMapLabel),
      PlotOpacity: getColor('PlotOpacity', ChartColors.PlotOpacity),
    }

    dispatch(accountSettings.Actions.setColor(mappedColors))
  }

  const localization = data.localizations?.[0]

  if (localization?.values) {
    const getLabel = (key: string, fallback: string) =>
      localization.values.find((x: any) => x.key === key)?.value ?? fallback

    const mappedLabels = {
      OnSite: getLabel('OnSite', ChartLabels.OnSite),
      Home: getLabel('Home', ChartLabels.Home),
      NoResponse: ChartLabels.NoResponse,
      NotWorking: getLabel('NotWorking', ChartLabels.NotWorking),
      Available: getLabel('Available', ChartLabels.Available),
      Reserved: getLabel('Reserved', ChartLabels.Reserved),
      InUse: getLabel('InUse', ChartLabels.InUse),
      Booked: getLabel('Booked', ChartLabels.Booked),
      Item: getLabel('Item', ChartLabels.Item),
      DefaultView: getLabel('DefaultView', ChartLabels.DefaultView),
      ConnectLabel: getLabel('ConnectLabel', ChartLabels.ConnectLabel),
      ConnectIcon: getLabel('ConnectIcon', ChartLabels.ConnectIcon),
      ConnectView: getLabel('ConnectView', ChartLabels.ConnectView),
    }

    dispatch(accountSettings.Actions.SetLocalization(mappedLabels))
  }

  return true
}
